import React, { useState, useEffect } from 'react';
import { updateUser } from '../../../http/UserAPI';

const SetUserNameModal = ({ onComplete }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!firstName.trim() || !lastName.trim()) {
            setError('Пожалуйста, заполните имя и фамилию.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            // 🔥 1. Сохраняем на сервер
            await updateUser({
                first_name: firstName.trim(),
                last_name: lastName.trim(),
            });

            // 🔥 2. Получаем текущего пользователя из localStorage
            const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

            // 🔥 3. Создаём нового пользователя, сохранив всё остальное
            const updatedUser = {
                ...currentUser,
                first_name: firstName.trim(),
                last_name: lastName.trim(),
            };

            // 🔥 4. Сохраняем обратно в localStorage
            localStorage.setItem('user', JSON.stringify(updatedUser));
            console.log('✅ Обновлённый пользователь в localStorage:', updatedUser);

            // 🔥 5. Закрываем модалку / обновляем страницу
            onComplete();
        } catch (err) {
            console.error('❌ Ошибка при обновлении имени и фамилии:', err);
            setError(err.message || 'Что-то пошло не так...');
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
                <h2 className="text-xl font-bold mb-4 text-center">Введите ваше имя и фамилию</h2>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <input
                        type="text"
                        placeholder="Имя"
                        className="border rounded px-4 py-2"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Фамилия"
                        className="border rounded px-4 py-2"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-[#6446C3] text-white py-2 rounded hover:bg-[#4d32a1] transition"
                    >
                        {loading ? 'Сохраняем...' : 'Сохранить'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SetUserNameModal;
